export default __webpack_public_path__ + "static/media/Osteoporosis_TheSilentCulprit.502e903f.pdf";